import { Flex } from "antd";
import { FC } from "react";
import { useIntl } from "react-intl";

interface EmptyTotalSectionProps {
  title: any;
  description: string;
  icon?: JSX.Element;
  secondTitle?: string;
  mini?: boolean;
  paddingX?: string;
  paddingY?: string;
  minHeight?: string;
  chartComponent?: JSX.Element;
  className?: any;
}
const arrowSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.06012 3.49414C5.06012 3.25252 5.256 3.05664 5.49762 3.05664L10.5051 3.05664C10.6212 3.05664 10.7324 3.10273 10.8145 3.18478C10.8965 3.26683 10.9426 3.37811 10.9426 3.49414L10.9426 8.50164C10.9426 8.74326 10.7467 8.93913 10.5051 8.93914C10.2635 8.93914 10.0676 8.74326 10.0676 8.50164L10.0676 3.93164L5.49762 3.93164C5.256 3.93164 5.06012 3.73577 5.06012 3.49414Z"
      fill="#9999A7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.18387 10.8155C3.01302 10.6446 3.01302 10.3676 3.18387 10.1967L10.1259 3.25472C10.2967 3.08387 10.5738 3.08387 10.7446 3.25472C10.9155 3.42558 10.9155 3.70259 10.7446 3.87344L3.80259 10.8155C3.63173 10.9863 3.35473 10.9863 3.18387 10.8155Z"
      fill="#9999A7"
    />
  </svg>
);

const EmptyTotalSection: FC<EmptyTotalSectionProps> = ({
  title,
  description,
  icon,
  secondTitle,
  minHeight,
  paddingX = "16px",
  paddingY = "16px",
  chartComponent,
  className,
}) => {
  const { locale } = useIntl();
  const intl = useIntl();

  return (
    <div
      className={`flex flex-col ${className} bg-white md:flex-row justify-between gap-4 my-2 px-[${paddingX}] py-[${paddingY}]  rounded-lg shadow   ${
        minHeight && `!min-h-[${minHeight}]`
      }`}
      style={{ border: "1px solid #E5E5E5" }}
    >
      <div>
        <div
          className={`flex flex-col   my-2 p-2  ${
            minHeight && `!min-h-[${minHeight}]`
          }`}
        >
          <div className="max-w-[190px]  space-y-3 text-center md:text-start">
            <p className="text-[#75757E] ms-2">{icon}</p>
            <p className="my-2 text-[#75757E]">{secondTitle}</p>

            <h2 className="text-[22px]  font-normal ">{title}</h2>
            <p className="text-[#75757E]">
              {arrowSVG}{" "}
              {intl.formatMessage({
                id: "salesDescription",
              })}
            </p>
          </div>
        </div>
      </div>
      {chartComponent ? (
        <div className="relative py-2">
          <div
            className={`${
              locale === "ar" ? "left-0" : "right-0"
            } absolute bottom-0 md:bottom-3 `}
          >
            {chartComponent}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default EmptyTotalSection;
